<div class="sb-text mb-1">
  <p class="font-weight-light mb-1">
    <ng-content select="[caption]"></ng-content>
  </p>

  <span><ng-content></ng-content></span>
</div>
